import styles from "./Hero.module.scss";
import Serce from "../../assets/images/hero/serce.svg";
import Lupa from "../../assets/images/hero/lupa.svg";
import Face from "../../assets/images/hero/interface.svg";
import Wieszak from "../../assets/images/hero/wieszak.svg";
import Kolo from "../../assets/images/hero/hero-img-kolo.svg";
import Kula from "../../assets/images/hero/hero-img-kula.svg";
import Menu from "../../assets/images/hero/hero-img-menu.svg";
import Okrag from "../../assets/images/hero/hero-img-okrag.svg";

export const Hero = () => {
  const {
    section__hero,
    wrapper__hero,
    hero__leftSide,
    hero__title,
    hero__titleS,
    hero__name,
    hero__content,
    hero__slogan,
    hero__anons,
    hero__button,
    hero__serce,
    hero__lupa,
    hero__wieszak,
    hero__kolo,
    hero__kula,
    hero__menu,
    hero__okrag,
    hero__rightSide,
    hero__face,
  } = styles;

  return (
    <section className={section__hero}>
      <div className={wrapper__hero}>
        <div className={hero__leftSide}>
          <h1 className={hero__title} data-aos="fade-right">
            Strony
            <span className={hero__titleS} data-aos="fade-right">
              {" "}
              Internetowe
            </span>
          </h1>
          <h2 className={hero__name} data-aos="fade-right" data-aos-delay="100">
            Marcin Mierzejewski
          </h2>
          <h2
            className={hero__content}
            data-aos="fade-right"
            data-aos-delay="150"
          >
            Projektowanie i tworzenie stron internetowych
          </h2>
          <h2
            className={hero__slogan}
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Daj się znaleźć w Internecie
          </h2>
          <h2
            className={hero__anons}
            data-aos="fade-right"
            data-aos-delay="250"
          >
            Zaloguj się do sieci!
          </h2>
          <div
            className={hero__button}
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <a href="#contact">
              <button className="button">Zamów usługę</button>
            </a>
          </div>
          <div>
            <img className={hero__serce} src={`${Serce}`} alt="Serce" />
            <img className={hero__lupa} src={`${Lupa}`} alt="Lupa" />
            <img className={hero__wieszak} src={`${Wieszak}`} alt="Wieszak" />
            <img className={hero__kolo} src={`${Kolo}`} alt="Kolo" />
            <img className={hero__kula} src={`${Kula}`} alt="Kula" />
            <img className={hero__menu} src={`${Menu}`} alt="Menu" />
            <img className={hero__okrag} src={`${Okrag}`} alt="Okrag" />
          </div>
        </div>
        <div
          className={hero__rightSide}
          data-aos="zoom-in"
          data-aos-delay="350"
        >
          <img className={hero__face} src={Face} alt="face" />
        </div>
      </div>
    </section>
  );
};
